export { default } from './BenefitsList';
export { default as adapter } from './adapter';
